import { useCallback } from 'react';
import { useMappedShortcutKeyViews } from '../../common/hooks/use-mapped-shortcut-key-views';

export function useGetDisplayedShortcutKeyByCommand() {
    const mappedShortcutKeyViews = useMappedShortcutKeyViews();

    return useCallback(
        (command: string) => {
            return mappedShortcutKeyViews
                .find((shortcutKeyView) => shortcutKeyView.shortcutCommand === command)
                ?.shortcutKeyCombination.toUpperCase();
        },
        [mappedShortcutKeyViews]
    );
}
